import React, { useContext } from 'react';
import './OtherMail.scss';
import MyContext from '../../Uttis/MyContext';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

const OtherMail = () => {
  const { showCustomForm, setShowCustomForm,savenameid,url ,setMessage,setSnack,setLoading,} = useContext(MyContext);

  return (
    <>
      {showCustomForm && (
        <div
          className="othermodal-overlay"
          onClick={() => setShowCustomForm(false)}
        >
          <div
            className="modal-contentother"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Send Email to <b>{savenameid.name}</b></h3>
              <span
                className="close-icon"
                onClick={() => setShowCustomForm(false)}
              >
                &times;
              </span>
            </div>

            <Formik
              initialValues={{ subject: '', message: '' }}
              validationSchema={Yup.object({
                subject: Yup.string().required('Subject is required'),
                message: Yup.string().required('Message is required'),
              })}
              onSubmit={async(values, { resetForm }) => {
                setLoading(true);
                document.querySelector("body").style.overflow = "hidden";
                try {
                const playlod = {
                  id: savenameid.id,
                  subject: values.subject,
                  message: values.message,
                };
               const{data} = await axios.post(`${url}/other-mail`, playlod);
                if (data.success) {
                  setSnack(true);
                  setMessage(data.message);
                  resetForm();
                  setShowCustomForm(false);
                } else {
                  setSnack(true);
                  setMessage(data.message);
                }
            }
                catch (error) {
console.error("Error sending email:", error);
setSnack(true);
setMessage("Something went wrong while sending the email.");
}
                finally {
                  setLoading(false);
                  document.querySelector("body").style.overflow = "auto";
                }
               

               
              }}
            >
              <Form className="email-form">
                <label>Subject</label>
                <Field name="subject" type="text" />
                <ErrorMessage name="subject" component="div" className="error" />

                <label>Message</label>
                <Field as="textarea" name="message" rows="18" />
                <ErrorMessage name="message" component="div" className="error" />

                <div className="form-buttons">
                  <button type="submit">Send</button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default OtherMail;
